import React, { createContext, useContext, useState, useEffect } from 'react';
import pb from '../lib/pocketbase';

const ContactContext = createContext();

export const useContactData = () => useContext(ContactContext);

export const ContactProvider = ({ children }) => {
    const [sections, setSections] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchContactData = async () => {
        setLoading(true);
        try {
            const records = await pb.collection('contact_sections').getFullList({
                sort: 'order',
                filter: 'is_published = true'
            });
            setSections(records);
        } catch (error) {
            console.error('Error fetching contact sections:', error);
            // Default sections if none found (fallback)
            setSections([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchContactData();
    }, []);

    return (
        <ContactContext.Provider value={{ sections, loading, refreshContactData: fetchContactData }}>
            {children}
        </ContactContext.Provider>
    );
};
